import { withNavigationWatcher } from "./contexts/navigation";
import {
  AppConfigurationPage,
  ParametersPage,
  LoginSecurity,
  LanguagePage,
} from "./pages";

const routes = [
  {
    path: "/app-configuration",
    component: AppConfigurationPage,
  },
  ,
  {
    path: "/parameters",
    component: ParametersPage,
  },

  {
    path: "/login-security",
    component: LoginSecurity,
  },

  {
    path: "/languages",
    component: LanguagePage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
